import UserManagement from '@/components/admin/UserManagement';

export default function UsersPage() {
  return (
    <section className="flex flex-col gap-4">
      <header>
        <h2 className="text-2xl font-semibold tracking-tight">User Management</h2>
        <p className="text-sm text-muted-foreground">
          Browse registered users, view state and assets, ban or delete.
        </p>
      </header>
      <UserManagement />
    </section>
  );
}
